import React from "react";
import { useSite } from "../context/SiteContext";
import useReveal from "../hooks/useReveal";

export default function Lineage() {
  useReveal();
  const { c } = useSite();
  const { lineage } = c;
  return (
    <section id="lineage" className="bg-ink2 py-28 sm:py-40">
      <div className="max-w-[1220px] mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <div className="flex items-center gap-4 mb-7">
            <span className="eyebrow">{lineage.label}</span>
          </div>
          <h2 className="font-display text-4xl sm:text-6xl font-light leading-[1.02] text-parchment">
            {lineage.title}
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-14 mt-16 items-start">
          <div className="reveal img-zoom relative lg:sticky lg:top-28">
            <img src={lineage.image} alt="The cave entrance in the Harz" className="w-full h-[520px] object-cover" />
            <div className="absolute inset-0 ring-1 ring-inset ring-gold/20" />
          </div>

          <ol className="relative border-l border-[var(--c-border)] pl-8">
            {lineage.events.map((e, i) => (
              <li
                key={i}
                className="reveal relative pb-12 last:pb-0"
                style={{ animationDelay: `${i * 90}ms` }}
              >
                <span className="absolute -left-[41px] top-1.5 w-3.5 h-3.5 rounded-full bg-gold ring-4 ring-ink2" />
                <span className="font-label text-[0.7rem] uppercase tracking-[0.24em] text-gold">{e.year}</span>
                <h3 className="font-display text-2xl sm:text-3xl font-medium text-parchment mt-2">{e.title}</h3>
                <p className="mt-2 text-lg leading-relaxed text-parchment/60 font-light">{e.text}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
